import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconUserCog } from '@tabler/icons-react';
import styles from './SystemAdminBadge.module.scss';

const SystemAdminBadge: React.FC = () => {
  const { t } = useTranslation('common');
  const label = t('systemAdmin.badge');

  return (
    <span className={styles.badge} title={label} aria-label={label} role="img">
      <IconUserCog size={20} stroke={1.8} />
    </span>
  );
};

export default SystemAdminBadge;
